module.exports = __webpack_public_path__ + "img/img-related01.23cdb9ca.jpg";